import { JuvenileCase } from './../juvenile-case';
import { SafeJSON } from './../../shared/safe-json';

export class CourtCosts {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getAbstractNumber(): string {
        return SafeJSON.get('abstractNumber', this.json);
    }
    getAbstractCode(): string {
        return SafeJSON.get('abstractCode', this.json);
    }
    getDetailNumber(): string {
        return SafeJSON.get('detailNumber', this.json);
    }
    getItemizedCostsDate(): string {
        return SafeJSON.get('date', this.json);
    }
    getItemizedCostsTypeOfCost(): string {
         return SafeJSON.get('costsType.description', this.json);
    }
    getItemizedCostsAmount(): string {
        return SafeJSON.get('amount', this.json);
    }
    getItemizedCostsPartyInfo(juvenileCase: JuvenileCase): string {
        let partyRef = SafeJSON.get('party.partyRole.code', this.json);
        partyRef = partyRef + SafeJSON.get('party.partyNumber', this.json);
        const name: string = juvenileCase.getPartyNameByPartyRef(partyRef);
        const description: string = juvenileCase.getPartyDescriptionByPartyRef(partyRef);
        const number: number = juvenileCase.getPartyNumberByPartyRef(partyRef);
        return name + ' (' + description + ' ' + number + ')';
    }
    getItemizedCostsIndigentCounty(): string {
        let field = SafeJSON.get('indigentCountyNumber', this.json);
        if (field !== '') {
            return 'INDIGENT';
    }
    return '-';
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/courtCosts.ts